<template>
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>
          <!-- 取引先
          <v-spacer></v-spacer>-->
          <v-text-field v-model="search" label="店舗コード検索" single-line hide-details></v-text-field>
          <!-- append-icon="search"-->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="stores"
          :search="search"
          hide-actions
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.storeCode }}</td>
              <td class="text-xs-left">{{ props.item.storeName }}</td>
              <td class="text-xs-left">{{ props.item.brandName }}</td>
              <td class="text-xs-left">
                {{ props.item.isActive === true ? '事前連絡する' : '事前連絡しない' }}
              </td>
              <td class="text-xs-center">
                <v-btn
                  icon
                  small
                  aria-label="編集"
                  @click="forwardOrderMailStoreEdit(props.item)"
                >
                  <v-icon small color="primary">edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
            >検索キーワード["{{ search }}]に該当する店舗は存在しません</v-alert>
          </template>
        </v-data-table>
        <br />
      </v-container>
    </v-card>

    <br />
    <v-layout row wrap class="button-area">
      <v-flex xs12 sm6 class="button-left">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>HOME
        </v-btn>
      </v-flex>

      <v-flex xs12 sm6 class="button-right">
        <v-btn block color="success" dark :to="{ name: 'admin/order-mail-target-store/new' }">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {

    ServerApiCallService.orderMailTargetStore()
      .then(response => {
        this.stores = response.data.orderMailTargetStores
      })
      .catch(error => {
        console.log('There was an error: orderMailTargetStore, ', error.response)
      })
  },
  methods: {
    forwardOrderMailStoreEdit(storeInfo) {
      this.$router.push({
        name: 'admin_order_mail_target_store_update',
        params: { storeCode: storeInfo.storeCode, isActive: storeInfo.isActive }
      })
    }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: '店舗コード', value: 'storeCode' },
        { text: '店舗名', value: 'storeName', sortable: false },
        { text: 'ブランド名', value: 'brandName', sortable: false },
        { text: 'ステータス', value: 'isActive', sortable: false },
        {
          text: '編集',
          value: 'edit',
          sortable: false,
          align: 'center'
        }
      ],
      stores: []
    }
  }
}
</script>

<style>
table.v-table thead th {
  font-size: 14px !important;  
  color: #333 !important;
}
.button-left {
  padding-right: 6px;
}

.button-right {
  padding-left: 6px;
}
.editable-row {
  cursor: pointer;
}

.editable-row:hover {
  background-color: #f5f7fa !important;
}
</style>
